import styled from "styled-components"

// Component
import SpecializationSelect from "./SpecializationSelect"

export type SpecializationSelectProps = {
  className?: string
  selected: string | null
  handleSelect(specialization: string | null): void
  handleContinue(): void
  handleBack(): void
}

const StyledSpecializationSelect = styled(SpecializationSelect)`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  
  & .label {
    color: ${({ theme }) => theme.color.gray};
    font-size: 16px;
    font-weight: bold;
    line-break: anywhere
  }
  
  & .item {
      padding: 20px;
      border-radius: 10px;
      background: ${({ theme }) => theme.color.white};
      box-shadow: 0 3px 20px -2px rgba(117, 140, 187, 0.19);
      border: 1px solid transparent;
      flex-basis: 48%;
      margin-bottom: 15px;
      text-align: center;
      cursor: pointer;
      opacity: 0.8;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  
  & .item__active {
      border-color: ${({ theme }) => theme.color.blue};
      opacity: 1;
  }
  
  & .anticon {
    position: absolute;
    top: 15px;
    right: 15px;
    color: ${({ theme }) => theme.color.blue}
  }
  
  & .ant-btn {
      margin-top: 8px;
  }
`;

export default StyledSpecializationSelect
